import { ElementType, LabelHTMLAttributes } from 'react';

export default <T extends ElementType = 'span'>(
  {
    value,
    required,
    className = '',
    children,
    as,
    ...props
  }:
    LabelHTMLAttributes<HTMLLabelElement> & {
    value?: string,
    required?: boolean
    as?: T
  }) => {
  const Component = as || 'a'
  const Content = () => <>
    {value ? value : children}
    {required && <span className={'color-error font-bold'}>&nbsp;*</span>}
  </>

  return <label {...props} className={className}>
    {!!as ? <Component><Content /></Component> : <Content />}
  </label>
}
